import React from 'react';

type Props = {
  title: string;
  value: string | number;
  subtitle: string;
  color: 'green' | 'orange' | 'red' | 'blue';
};

const colorMap = {
  green: {
    dot: 'bg-emerald-500',
    text: 'text-emerald-600',
    bar: 'bg-emerald-500',
  },
  orange: {
    dot: 'bg-orange-500',
    text: 'text-orange-600',
    bar: 'bg-orange-500',
  },
  red: {
    dot: 'bg-red-500',
    text: 'text-red-600',
    bar: 'bg-red-500',
  },
  blue: {
    dot: 'bg-blue-500',
    text: 'text-blue-600',
    bar: 'bg-blue-500',
  },
};

export const ExtendedStatCard = ({ title, value, subtitle, color }: Props) => {
  const c = colorMap[color];

  return (
    <div className="rounded-xl border dark:border-gray-700 bg-white dark:bg-slate-900 overflow-hidden">
      <div className={`h-1 ${c.bar}`} />

      <div className="p-4">
        <div className="flex items-center justify-between">
          <span className="text-[11px] uppercase tracking-wider text-zinc-500">
            {title}
          </span>

          <div className="flex items-center gap-1">
            <div className={`h-2 w-2 rounded-full ${c.dot}`} />
            <span className={`text-xs font-medium ${c.text}`}>
              {color === 'green'
                ? 'Healthy'
                : color === 'orange'
                  ? 'Attention'
                  : 'Issue'}
            </span>
          </div>
        </div>

        <div className="mt-3 text-3xl font-bold">{value}</div>

        <div className="mt-2 text-xs text-zinc-500">{subtitle}</div>
      </div>
    </div>
  );
};
